import { render } from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=template&id=7642b43e"
import script from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"

import "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=style&index=0&id=7642b43e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__